import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { apiWrapper } from "../../../api/apiWrapper";
import { IHocSinhAceChiTietLoadStart } from '../../../models/request/hoc-sinh/IHocSinhAceChiTietLoadStart';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { IBoDoiCongAn } from '../../../models/response/hoc-sinh/IBoDoiCongAn';
import { eBoDoiCongAnActionTypeIds, IBoDoiCongAnActionTypes } from '../../action-types/bodoi-congan/IBoDoiCongAnActionTypes';
import { actions } from '../../actions/actionsWrapper';


export function* boDoiCongAnSaga(): any {
    yield takeLatest(eBoDoiCongAnActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eBoDoiCongAnActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eBoDoiCongAnActionTypeIds.DELETE_START, deleteWorker)


}

function* loadWorker(action: IBoDoiCongAnActionTypes): any {
    const payload: IHocSinhAceChiTietLoadStart = action.payload as IHocSinhAceChiTietLoadStart;

    const res: IBaseResponeModel = yield call(apiWrapper.boDoiCongAn.select_all_by_hocsinh, payload)
    if (res.is_success) {
        yield put(actions.boDoiCongAn.LOAD_SUCCESS(res.data))
    } else {
        yield put(actions.boDoiCongAn.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IBoDoiCongAnActionTypes): any {
    const payload: IBoDoiCongAn = action.payload as IBoDoiCongAn;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.boDoiCongAn.update, payload)
    } else {
        res = yield call(apiWrapper.boDoiCongAn.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.boDoiCongAn.SAVE_SUCESS(res.data))
    } else {
        yield put(actions.boDoiCongAn.SAVE_ERROR(res.message ?? "Error"))
    }
}

function* deleteWorker(action: IBoDoiCongAnActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.boDoiCongAn.delete, payload)
    if (res.is_success) {
        yield put(actions.boDoiCongAn.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.boDoiCongAn.DELETE_ERROR(res.message ?? "Error"))
    }
}
